// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBEtocPfBFx1Yyuu6-8USl1IYO57Uyw26k",
  authDomain: "freakers-20b03.firebaseapp.com",
  projectId: "freakers-20b03",
  storageBucket: "freakers-20b03.firebasestorage.app",
  messagingSenderId: "29839685244",
  appId: "1:29839685244:web:8adda104c366e7c9c1bbf9",
  measurementId: "G-2PWHJT43FQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;



